import styled, { css } from 'styled-components';

export const CollapsibleTrigger = styled.div`
  cursor: pointer;
  display: flex;
  align-items: center;

  & > div:first-child {
    width: 100%;
  }
`;

export const CollapsibleContent = styled.div<{
  isClosed: boolean;
  transitioning: boolean;
}>`
  display: flex;
  flex-direction: column;
  clear: both;
  transition: height ${({ theme: { collapsible } }) => collapsible.duration}ms ease;

  ${({ isClosed }) =>
    isClosed &&
    css`
      display: none;
    `};

  ${({ transitioning }) =>
    transitioning &&
    css`
      overflow: hidden;
    `};
`;
